export const collegeStateOrder = [
  "Maharashtra",
  "Gujarat",
  "Rajasthan",
  "Delhi NCR",
  "Madhya Pradesh",
  "Tamil Nadu",
  "Karnataka",
  "Telangana"
];

export const collegeCategoryMeta = {
  bachelors: { label: "Bachelor's", tone: "bg-brand-sky/55 text-brand-navy" },
  masters: { label: "Master's", tone: "bg-brand-gold-soft text-brand-charcoal" },
  "mbbs-india": { label: "MBBS India", tone: "bg-emerald-50 text-emerald-800" },
  "mbbs-abroad-guidance": {
    label: "MBBS Abroad Guidance",
    tone: "bg-indigo-50 text-indigo-800"
  }
};

export const collegePathwayFilters = [
  { value: "all", label: "All Pathways" },
  { value: "bachelors", label: "Bachelor's" },
  { value: "masters", label: "Master's" },
  { value: "mbbs-india", label: "MBBS India" },
  { value: "mbbs-abroad-guidance", label: "MBBS Abroad Guidance" },
  { value: "featured", label: "Featured" }
];

const stateIndexMap = new Map(collegeStateOrder.map((state, index) => [state, index]));

const toSlug = (value) =>
  value
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

const collegeCatalogSeed = [
  {
    name: "Sandip University",
    state: "Maharashtra",
    location: "Nashik, Maharashtra",
    categoryTags: ["bachelors", "masters"],
    featured: true,
    description: "A frequently discussed multidisciplinary option for undergraduate and postgraduate planning.",
    shortLabel: "Sandip",
    order: 1
  },
  {
    name: "DYP Patil (Intellipaat)",
    state: "Maharashtra",
    location: "Pune, Maharashtra",
    categoryTags: ["bachelors", "masters"],
    featured: true,
    description: "Evaluated in counselling for industry-linked programs and pathway flexibility.",
    shortLabel: "DYP Patil",
    order: 2,
    sourceAliases: ["DYP Patil (Intellipath)"]
  },
  {
    name: "Sanjay Ghodawat University",
    state: "Maharashtra",
    location: "Kolhapur, Maharashtra",
    categoryTags: ["bachelors", "masters"],
    featured: false,
    description: "Considered by families looking for regional access with broad course choices.",
    shortLabel: "SGU",
    order: 3,
    sourceAliases: ["Sanjay Godawat"]
  },
  {
    name: "PP Savani University",
    state: "Gujarat",
    location: "Surat, Gujarat",
    categoryTags: ["bachelors", "masters"],
    featured: false,
    description: "Often shortlisted for students comparing Gujarat-based private university options.",
    shortLabel: "PP Savani",
    order: 1,
    sourceAliases: ["PPSavani"]
  },
  {
    name: "Marwadi University",
    state: "Gujarat",
    location: "Rajkot, Gujarat",
    categoryTags: ["bachelors", "masters"],
    featured: false,
    description: "A common inclusion for profile-led comparisons across western India.",
    shortLabel: "Marwadi",
    order: 2
  },
  {
    name: "Ganpat University",
    state: "Gujarat",
    location: "Mehsana, Gujarat",
    categoryTags: ["bachelors", "masters"],
    featured: false,
    description: "Reviewed when families seek balanced course variety and location practicality.",
    shortLabel: "Ganpat",
    order: 3
  },
  {
    name: "Swaminarayan University",
    state: "Gujarat",
    location: "Kalol, Gujarat",
    categoryTags: ["bachelors", "masters"],
    featured: false,
    description: "Explored for students looking at emerging Gujarat campus ecosystems.",
    shortLabel: "Swaminarayan",
    order: 4,
    sourceAliases: ["Swami Narayan"]
  },
  {
    name: "Parul University",
    state: "Gujarat",
    location: "Vadodara, Gujarat",
    categoryTags: ["bachelors", "masters"],
    featured: true,
    description: "A widely discussed option during counselling for breadth of academic pathways.",
    shortLabel: "Parul",
    order: 5
  },
  {
    name: "NIMS University",
    state: "Rajasthan",
    location: "Jaipur, Rajasthan",
    categoryTags: ["bachelors", "masters", "mbbs-india"],
    featured: true,
    description: "Frequently reviewed by students exploring health sciences and multidisciplinary options.",
    shortLabel: "NIMS",
    order: 1,
    sourceAliases: ["NIMS"]
  },
  {
    name: "Suresh Gyan Vihar University",
    state: "Rajasthan",
    location: "Jaipur, Rajasthan",
    categoryTags: ["bachelors", "masters"],
    featured: false,
    description: "Included in counselling discussions for structured private university pathways.",
    shortLabel: "SGVU",
    order: 2,
    sourceAliases: ["Suresh Gyan Vihar"]
  },
  {
    name: "GD Goenka University",
    state: "Delhi NCR",
    location: "Gurugram, Delhi NCR",
    categoryTags: ["bachelors", "masters"],
    featured: true,
    description: "Commonly compared for students aiming for Delhi NCR ecosystem access.",
    shortLabel: "GD Goenka",
    order: 1,
    sourceAliases: ["GD Goenka"]
  },
  {
    name: "Sharda University",
    state: "Delhi NCR",
    location: "Greater Noida, Delhi NCR",
    categoryTags: ["bachelors", "masters"],
    featured: true,
    description: "A regular shortlist option for families preferring Greater Noida-based campuses.",
    shortLabel: "Sharda",
    order: 2,
    sourceAliases: ["Sharadha"]
  },
  {
    name: "Bennett University",
    state: "Delhi NCR",
    location: "Greater Noida, Delhi NCR",
    categoryTags: ["bachelors", "masters"],
    featured: false,
    description: "Often evaluated in counselling for urban career-oriented program choices.",
    shortLabel: "Bennett",
    order: 3,
    sourceAliases: ["Bennet"]
  },
  {
    name: "IILM University",
    state: "Delhi NCR",
    location: "Gurugram, Delhi NCR",
    categoryTags: ["bachelors", "masters"],
    featured: false,
    description: "Compared when students explore management and interdisciplinary pathways.",
    shortLabel: "IILM",
    order: 4,
    sourceAliases: ["IILM"]
  },
  {
    name: "Sanskriti University",
    state: "Delhi NCR",
    location: "Mathura, NCR Region",
    categoryTags: ["bachelors", "masters"],
    featured: false,
    description: "Considered in practical shortlist rounds for nearby NCR-influenced regions.",
    shortLabel: "Sanskriti",
    order: 5,
    sourceAliases: ["Sanskriti"]
  },
  {
    name: "K N Modi University",
    state: "Delhi NCR",
    location: "Ghaziabad, Delhi NCR",
    categoryTags: ["bachelors", "masters"],
    featured: false,
    description: "Discussed for students who want NCR familiarity with structured campus options.",
    shortLabel: "KN Modi",
    order: 6,
    sourceAliases: ["KN Modi"]
  },
  {
    name: "ITM University Gwalior",
    state: "Madhya Pradesh",
    location: "Gwalior, Madhya Pradesh",
    categoryTags: ["bachelors", "masters"],
    featured: true,
    description: "A known counselling option for students balancing academics and regional accessibility.",
    shortLabel: "ITM",
    order: 1,
    sourceAliases: ["ITM Gwalior"]
  },
  {
    name: "Dhanalakshmi Srinivasan University",
    state: "Tamil Nadu",
    location: "Tiruchirappalli, Tamil Nadu",
    categoryTags: ["bachelors", "masters", "mbbs-india"],
    featured: false,
    description: "Evaluated by families comparing Tamil Nadu options for health and allied pathways.",
    shortLabel: "DSU",
    order: 1,
    sourceAliases: ["Dhanalakshmi Srinivas"]
  },
  {
    name: "Bharath University",
    state: "Tamil Nadu",
    location: "Chennai, Tamil Nadu",
    categoryTags: ["bachelors", "masters", "mbbs-india"],
    featured: true,
    description: "Frequently explored during counselling for broad academic and medical-track discussions.",
    shortLabel: "Bharath",
    order: 2,
    sourceAliases: ["Bharath"]
  },
  {
    name: "Dr. MGR University",
    state: "Tamil Nadu",
    location: "Chennai, Tamil Nadu",
    categoryTags: ["bachelors", "masters", "mbbs-india"],
    featured: false,
    description: "Included in shortlist conversations for medical-linked and core degree pathways.",
    shortLabel: "Dr. MGR",
    order: 3,
    sourceAliases: ["Dr. MGR"]
  },
  {
    name: "SAI University",
    state: "Tamil Nadu",
    location: "Chennai, Tamil Nadu",
    categoryTags: ["bachelors", "masters"],
    featured: false,
    description: "Considered for students evaluating modern multidisciplinary program structures.",
    shortLabel: "SAI",
    order: 4
  },
  {
    name: "Amrita Vishwa Vidyapeetham",
    state: "Tamil Nadu",
    location: "Coimbatore, Tamil Nadu",
    categoryTags: ["bachelors", "masters", "mbbs-india"],
    featured: true,
    description: "A strong reference point in counselling for students targeting reputed institutions.",
    shortLabel: "Amrita",
    order: 5,
    sourceAliases: ["Amrita"]
  },
  {
    name: "SRM Institute of Science and Technology",
    state: "Tamil Nadu",
    location: "Chennai, Tamil Nadu",
    categoryTags: ["bachelors", "masters"],
    featured: true,
    description: "Popular in counselling discussions for scale, recognizability, and program variety.",
    shortLabel: "SRM",
    order: 6,
    sourceAliases: ["SRM"]
  },
  {
    name: "VIT",
    state: "Tamil Nadu",
    location: "Vellore, Tamil Nadu",
    categoryTags: ["bachelors", "masters"],
    featured: true,
    description: "Often shortlisted for academically focused students comparing competitive pathways.",
    shortLabel: "VIT",
    order: 7,
    sourceAliases: ["VIT"]
  },
  {
    name: "Hindustan Institute of Technology and Science",
    state: "Tamil Nadu",
    location: "Chennai, Tamil Nadu",
    categoryTags: ["bachelors", "masters", "mbbs-india"],
    featured: false,
    description: "Reviewed for students looking at Chennai-based private university environments.",
    shortLabel: "HITS",
    order: 8,
    sourceAliases: ["Hindustan Chennai"]
  },
  {
    name: "SVYASA University",
    state: "Karnataka",
    location: "Bengaluru, Karnataka",
    categoryTags: ["bachelors", "masters"],
    featured: false,
    description: "Explored in counselling for students interested in wellness-focused academic tracks.",
    shortLabel: "SVYASA",
    order: 1,
    sourceAliases: ["S-VYass"]
  },
  {
    name: "Harsha Institutions",
    state: "Karnataka",
    location: "Bengaluru, Karnataka",
    categoryTags: ["bachelors", "masters"],
    featured: false,
    description: "Considered for students reviewing Bengaluru-centered institutional options.",
    shortLabel: "Harsha",
    order: 2,
    sourceAliases: ["Harsha"]
  },
  {
    name: "Akash Institute",
    state: "Karnataka",
    location: "Bengaluru, Karnataka",
    categoryTags: ["bachelors", "masters"],
    featured: false,
    description: "Included in practical shortlists where specialization and location both matter.",
    shortLabel: "Akash",
    order: 3,
    sourceAliases: ["Akash"]
  },
  {
    name: "East Point Group of Institutions",
    state: "Karnataka",
    location: "Bengaluru, Karnataka",
    categoryTags: ["bachelors", "masters"],
    featured: false,
    description: "Frequently compared during counselling for broad-course campus planning.",
    shortLabel: "East Point",
    order: 4,
    sourceAliases: ["East Point"]
  },
  {
    name: "St. Peter's Institute",
    state: "Karnataka",
    location: "Bengaluru, Karnataka",
    categoryTags: ["bachelors", "masters"],
    featured: false,
    description: "A practical consideration in location-aware shortlisting discussions.",
    shortLabel: "St Peter",
    order: 5,
    sourceAliases: ["St Peter"]
  },
  {
    name: "Presidency University",
    state: "Karnataka",
    location: "Bengaluru, Karnataka",
    categoryTags: ["bachelors", "masters"],
    featured: true,
    description: "A regular counselling shortlist option for students preferring Bengaluru opportunities.",
    shortLabel: "Presidency",
    order: 6,
    sourceAliases: ["Presidency"]
  },
  {
    name: "Kishkinda University",
    state: "Karnataka",
    location: "Ballari, Karnataka",
    categoryTags: ["bachelors", "masters"],
    featured: false,
    description: "Discussed for families evaluating Karnataka options outside metro clusters.",
    shortLabel: "Kishkinda",
    order: 7,
    sourceAliases: ["Kishkinda"]
  },
  {
    name: "Malla Reddy University",
    state: "Telangana",
    location: "Hyderabad, Telangana",
    categoryTags: ["bachelors", "masters"],
    featured: true,
    description: "A key Telangana option frequently reviewed in counselling conversations.",
    shortLabel: "MRU",
    order: 1,
    sourceAliases: ["Mallareddy University", "Malla Reddy University"]
  },
  {
    name: "Malla Reddy Vishwavidyapeeth",
    state: "Telangana",
    location: "Hyderabad, Telangana",
    categoryTags: ["bachelors", "masters"],
    featured: false,
    description: "Normalized entry representing similarly named institutional references in the list.",
    shortLabel: "MRV",
    order: 2,
    sourceAliases: ["Mallareddy Vishwa Vidyapeeth", "Malla Reddy Vishwavidyapeet"]
  },
  {
    name: "Malla Reddy Deemed to be University",
    state: "Telangana",
    location: "Hyderabad, Telangana",
    categoryTags: ["bachelors", "masters"],
    featured: false,
    description: "Included for families comparing institutional tracks within the Malla Reddy network.",
    shortLabel: "MRDU",
    order: 3
  },
  {
    name: "Guru Nanak Institutions (Intellipaat)",
    state: "Telangana",
    location: "Hyderabad, Telangana",
    categoryTags: ["bachelors", "masters", "mbbs-abroad-guidance"],
    featured: false,
    description: "Appears in counselling when families evaluate partnered program delivery models.",
    shortLabel: "Guru Nanak",
    order: 4,
    sourceAliases: ["Gurunanak (Intellipath)"]
  },
  {
    name: "Chaitanya University (NxtWave Pathway)",
    state: "Telangana",
    location: "Hyderabad, Telangana",
    categoryTags: ["bachelors", "masters", "mbbs-abroad-guidance"],
    featured: false,
    description: "Consolidated representation of Chaitanya entries mentioned in the source list.",
    shortLabel: "Chaitanya",
    order: 5,
    sourceAliases: ["Chaitanya", "Chaitanya (NXT WAVE)"]
  },
  {
    name: "Kaveri University",
    state: "Telangana",
    location: "Hyderabad, Telangana",
    categoryTags: ["bachelors", "masters"],
    featured: false,
    description: "Considered in local counselling comparisons for Hyderabad-region planning.",
    shortLabel: "Kaveri",
    order: 6,
    sourceAliases: ["Kaveri"]
  },
  {
    name: "Amity University Hyderabad",
    state: "Telangana",
    location: "Hyderabad, Telangana",
    categoryTags: ["bachelors", "masters", "mbbs-abroad-guidance"],
    featured: true,
    description: "A recurring shortlist option for families seeking established private university ecosystems.",
    shortLabel: "Amity",
    order: 7,
    sourceAliases: ["Amity"]
  },
  {
    name: "Intellipaat Partner Programs",
    state: "Telangana",
    location: "Hyderabad, Telangana",
    categoryTags: ["bachelors", "masters", "mbbs-abroad-guidance"],
    featured: false,
    description: "Used in guidance conversations when industry-integrated learning pathways are evaluated.",
    shortLabel: "Intellipaat",
    order: 8,
    sourceAliases: ["Intellipath"]
  },
  {
    name: "NxtWave Industry Pathways",
    state: "Telangana",
    location: "Hyderabad, Telangana",
    categoryTags: ["bachelors", "masters", "mbbs-abroad-guidance"],
    featured: false,
    description: "Included for students comparing newer skill-integrated academic route options.",
    shortLabel: "NxtWave",
    order: 9,
    sourceAliases: ["Nxt Wave"]
  },
  {
    name: "St. Mary's Rehab University",
    state: "Telangana",
    location: "Hyderabad, Telangana",
    categoryTags: ["bachelors", "masters"],
    featured: false,
    description: "Reviewed in niche counselling conversations for rehabilitation-linked programs.",
    shortLabel: "St Mary's",
    order: 10,
    sourceAliases: ["St Mary's Rehab University"]
  },
  {
    name: "Woxsen University",
    state: "Telangana",
    location: "Hyderabad, Telangana",
    categoryTags: ["bachelors", "masters"],
    featured: true,
    description: "A notable Hyderabad option often included in premium private university comparisons.",
    shortLabel: "Woxsen",
    order: 11
  },
  {
    name: "ICFAI University Hyderabad",
    state: "Telangana",
    location: "Hyderabad, Telangana",
    categoryTags: ["bachelors", "masters"],
    featured: true,
    description: "Regularly reviewed for management and career-focused program pathways.",
    shortLabel: "ICFAI",
    order: 12,
    sourceAliases: ["ICFAI"]
  },
  {
    name: "Vishwa Vishwani Institute",
    state: "Telangana",
    location: "Hyderabad, Telangana",
    categoryTags: ["bachelors", "masters"],
    featured: false,
    description: "Included in shortlist discussions for students preferring Hyderabad-based choices.",
    shortLabel: "Vishwa Vishwani",
    order: 13,
    sourceAliases: ["Vishwa Vishwani"]
  }
];

const normalizedCatalog = collegeCatalogSeed.map((college) => {
  const id = college.id || toSlug(college.name);

  return {
    id,
    slug: id,
    name: college.name,
    state: college.state,
    location: college.location,
    categoryTags: college.categoryTags || ["bachelors", "masters"],
    featured: Boolean(college.featured),
    description: college.description,
    logoKey: college.logoKey || id,
    shortLabel: college.shortLabel || college.name.split(" ")[0],
    order: college.order || 1,
    sourceAliases: college.sourceAliases || []
  };
});

export const allColleges = normalizedCatalog.sort((a, b) => {
  const stateDiff = (stateIndexMap.get(a.state) ?? 999) - (stateIndexMap.get(b.state) ?? 999);
  if (stateDiff !== 0) {
    return stateDiff;
  }

  return a.order - b.order;
});

export const collegesByState = collegeStateOrder.map((state) => ({
  state,
  colleges: allColleges.filter((college) => college.state === state)
}));

const featuredCollegeIds = [
  "sandip-university",
  "dyp-patil-intellipaat",
  "parul-university",
  "nims-university",
  "gd-goenka-university",
  "itm-university-gwalior",
  "srm-institute-of-science-and-technology",
  "vit",
  "presidency-university",
  "malla-reddy-university",
  "woxsen-university",
  "icfai-university-hyderabad"
];

export const featuredColleges = featuredCollegeIds
  .map((id) => allColleges.find((college) => college.id === id))
  .filter(Boolean);

export const collegeStateFilters = [
  { value: "all", label: "All States" },
  ...collegeStateOrder.map((state) => ({ value: state, label: state }))
];

export const collegeOverview = {
  stateCount: collegeStateOrder.length,
  collegeCount: allColleges.length,
  featuredCount: allColleges.filter((college) => college.featured).length,
  featuredShowcaseCount: featuredColleges.length
};

export const collegesPageContent = {
  meta: {
    title: "College Exploration | TheCareerSpace Admissions Guidance",
    description:
      "Browse TheCareerSpace college coverage by state and pathway to prepare for focused counselling and shortlist discussions."
  },
  hero: {
    badge: "College Exploration",
    title: "Explore colleges across states with a clear, counselling-first structure.",
    description:
      "Use this page to scan featured institutions, browse by state, and identify pathways before speaking with TheCareerSpace for shortlist guidance.",
    highlights: [
      "Organized across 8 states",
      "Pathway-based filtering",
      "Profile-led counselling support"
    ]
  },
  browseNotes: [
    "Use state filters to narrow geography quickly.",
    "Use pathway filters to align college browsing with admission goals.",
    "Featured colleges are commonly discussed during counselling."
  ],
  trustCards: [
    {
      title: "Students get shortlist clarity",
      text: "College discussions are mapped to profile, goals, and practical fit instead of random longlists."
    },
    {
      title: "Parents get transparent comparisons",
      text: "Counselling helps families compare options calmly with better visibility on trade-offs."
    },
    {
      title: "Decisions become more structured",
      text: "Organized college exploration reduces confusion and supports more confident next steps."
    }
  ]
};
